module.exports = __webpack_public_path__ + "img/spirit_small_1.cccc1cd7.png";